export const FIREBASE_CONFIG = {
  apiKey: "AIzaSyAwDSvCoCt2r6cTpaBxKJIrZvG-NCEGqTE",
  authDomain: "jaiminhobot.firebaseapp.com",
  projectId: "jaiminhobot",
  storageBucket: "jaiminhobot.appspot.com",
  messagingSenderId: "459804259930",
  appId: "1:459804259930:web:eddfd7d2ee7fc03a1dca63",
  measurementId: "G-W90DMM4EPW"
};